import React, { useCallback, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { IdMeStatus } from '@pff-consumer/schema'
import { checkoutHooks } from '@pff-consumer/data-provider/lib/checkout/checkout.hooks'
import { SubscriptionLayout } from '@pff-consumer/feature-account/components/subscription-layout/subscription-layout.web'
import { Toast } from '@pff-consumer/tweed-ui/atoms/toast/toast.web'
import { IDME_VERIFICATION_ERROR_MESSAGE } from '@pff-consumer/utils/lib/accounts/constants'
import { PffInsights } from '../common/pff-insights/pff-insights'

const { useBreakpoints } = checkoutHooks

export const Subscription = () => {
  const { isDesktop } = useBreakpoints()
  const idmeStatus = new URLSearchParams(window.location.search).get('idmeStatus')

  const isIdmeVerificationError = idmeStatus === IdMeStatus.ERROR
  const hasIdmeStatusQuery = Boolean(idmeStatus)
  const [openToast, setOpenToast] = useState(isIdmeVerificationError)
  const router = useRouter()

  const handleToastClose = useCallback(() => {
    setOpenToast(false)
  }, [])

  useEffect(() => {
    const query = { ...router.query }
    delete query.idmeStatus
    delete query.error

    if (hasIdmeStatusQuery) {
      router.replace(
        {
          pathname: router.pathname,
          query,
        },
        undefined,
        { shallow: true }
      )
    }
    // only want to run this once on mount
  }, [])

  return (
    <>
      {!isDesktop && <PffInsights />}
      <SubscriptionLayout />

      <Toast
        showToast={openToast}
        hasErrored
        errorMessage={IDME_VERIFICATION_ERROR_MESSAGE}
        onClose={handleToastClose}
      />
    </>
  )
}
